var LoadingPerspective = require('./LoadingPerspective');

/**
 * Loading Perspective for Admin Tools
 *
 * @class AdminLoadingPerspective
 */
var PortalLoadingPerspective = LoadingPerspective.extend({
  hasPageHeader: false,
  hasSubHeader: false,
  hasAside: true,
  hasPageFooter: true
});

module.exports = new PortalLoadingPerspective();
